export const syllabusRoutesData1 = [
    {
      name: "CSE",
      to: "/syllabus1/cse1",
      expansion: "Computer Science and Engineering",
    },
    {
      name: "IT",
      to: "/syllabus1/it1",
      expansion: "Information Technology",
    },
    {
      name: "ECE",
      to: "/syllabus1/ece1",
      expansion: "Electronics and Communication Engineering",
    },
    {
      name: "EEE",
      to: "/syllabus1/eee1",
      expansion: "Electrical and Electronics Engineering",
    },
    {
      name: "MECH",
      to: "/syllabus1/mech1",
      expansion: "Mechanical Engineering",
    },
    {
      name: "BME",
      to: "/syllabus1/auto1",
      expansion: "Bio Medical Engineering",
    },
    {
      name: "CIVIL",
      to: "/syllabus1/civil1",
      expansion: "Civil Engineering",
    },
    {
      name: "FT",
      to: "/syllabus1/ft1",
      expansion: "Fashion Technology",
    },
    {
      name: "MCT",
      to: "/syllabus1/mct1",
      expansion: "Mechatronics Engineering",
    },
    {
      name: "ADS",
      to: "/syllabus1/ads1",
      expansion: "Artificial Intelligence and Data Science",
    },
    {
      name: "AIML",
      to: "/syllabus1/aiml1",
      expansion: "Artificial Intelligence and Machine Learning",
    },
    {
      name: "CSD",
      to: "/syllabus1/csd1",
      expansion: "Computer Science and Design",
    },
    {
      name: "EFE",
      to: "/syllabus1/ecce1",
      expansion: "Electrical and Computer Engineering",
    },
    {
      name: "EXE",
      to: "/syllabus1/eece1",
      expansion: "Electronics and Computer Engineering",
    },
        {
      name: "CSB",
      to: "/syllabus1/csb1",
      expansion: "Computer Science and Business Intelligence",
    },
        {
      name: "CSECS",
      to: "/syllabus1/csecs1",
      expansion: "Computer Science and Engineering (Cyber Security)",
    },
        {
      name: "FSE",
      to: "/syllabus1/fse1",
      expansion: "Safety and Fire Engineering",
    },
        {
      name: "VLSI",
      to: "/syllabus1/vlsi1",
      expansion: "Electronics Engineering (VLSI Design and Tech)",
    },
  ];
  